export const BOLARENA_EMAIL = 'bolarena.app@gmail.com';